const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <div className="max-w-4xl mx-auto p-6 py-12">
        <h1 className="text-4xl font-bold mb-6 text-red-500">Contact</h1>
        <div className="space-y-4">
          <p className="text-xl text-gray-300 leading-relaxed">
            If you have any questions or suggestions, please feel free to contact me.
          </p>
          <p className="text-xl text-gray-300">
            Email:{" "}
            <a href="mailto:support@noleyo.com" className="text-red-400 hover:text-red-300 underline transition-colors">
              support@noleyo.com
            </a>
          </p>
          <p className="text-xl text-gray-500">Instagram: Soon</p>
          <p className="text-xl text-gray-500">Twitter: Soon</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
